import { Area, AreaChart, ResponsiveContainer, YAxis, Tooltip } from "recharts";

export function Sparkline({ data = [], color = "#D4AF37", height = 56 }) {
  if (!data || data.length === 0) return <div style={{ height }} />;
  const chartData = data.map((p, i) => ({ i, p }));
  const min = Math.min(...data);
  const max = Math.max(...data);
  const gid = `spark-${color.replace("#", "")}`;
  return (
    <ResponsiveContainer width="100%" height={height}>
      <AreaChart data={chartData} margin={{ top: 2, right: 0, bottom: 0, left: 0 }}>
        <defs>
          <linearGradient id={gid} x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor={color} stopOpacity={0.5} />
            <stop offset="100%" stopColor={color} stopOpacity={0} />
          </linearGradient>
        </defs>
        <YAxis hide domain={[min, max]} />
        <Area type="monotone" dataKey="p" stroke={color} strokeWidth={1.8} fill={`url(#${gid})`} isAnimationActive={false} />
      </AreaChart>
    </ResponsiveContainer>
  );
}

export function PriceChart({ data = [], color = "#D4AF37", height = 260, currency = "EUR" }) {
  if (!data || data.length === 0) return <div style={{ height }} className="flex items-center justify-center text-white/30 text-sm">Loading chart…</div>;
  const step = Math.max(1, Math.floor(data.length / 120));
  const chartData = data.filter((_, i) => i % step === 0).map((p, i) => ({ i, price: p }));
  const min = Math.min(...data);
  const max = Math.max(...data);
  const fmt = (v) => new Intl.NumberFormat("en-US", { style: "currency", currency, maximumFractionDigits: 0 }).format(v);
  return (
    <ResponsiveContainer width="100%" height={height}>
      <AreaChart data={chartData} margin={{ top: 8, right: 8, bottom: 0, left: 0 }}>
        <defs>
          <linearGradient id="priceFill" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor={color} stopOpacity={0.35} />
            <stop offset="100%" stopColor={color} stopOpacity={0} />
          </linearGradient>
        </defs>
        <YAxis hide domain={[min * 0.998, max * 1.002]} />
        <Tooltip
          contentStyle={{ background: "rgba(13,21,51,0.95)", border: "1px solid rgba(255,255,255,0.12)", borderRadius: 10, fontFamily: "JetBrains Mono", fontSize: 12 }}
          labelFormatter={() => ""}
          formatter={(v) => [fmt(v), ""]}
        />
        <Area type="monotone" dataKey="price" stroke={color} strokeWidth={2} fill="url(#priceFill)" isAnimationActive={true} />
      </AreaChart>
    </ResponsiveContainer>
  );
}
